import { Pipe, PipeTransform } from '@angular/core';
import { AnatomicalSideEnum, LanguageService } from '../../core';


/**
 * Pipe to convert Anatomical Side enum to display value.
 */
@Pipe({
	name: 'anatomicalSideLabel'
})
export class AnatomicalSideLabelPipe implements PipeTransform {

	constructor(private readonly langSrv: LanguageService) { }

	transform(side: AnatomicalSideEnum): string {
		return anatomicalSideTranslate(side, this.langSrv.labels());
	}

}

export const anatomicalSideTranslate = (side: AnatomicalSideEnum, labels: any): string => {
	switch (side) {
		case AnatomicalSideEnum.Left: return labels.ANATOMICAL_SIDE_LEFT;
		case AnatomicalSideEnum.Right: return labels.ANATOMICAL_SIDE_RIGHT;
		default: return side;
	}
}
